import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { OpenDialogSearchMobileComponent } from 'app/components/dialog/open-dialog-search-mobile/open-dialog-search-mobile.component';
import { MainMenu } from 'app/shared/models/class/menu/menu';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { MenuService } from 'app/shared/services/menu/menu.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-header-home',
  templateUrl: './header-home.component.html',
  styleUrls: ['./header-home.component.scss'],
})
export class HeaderHomeComponent extends SubscriptionBaseComponent implements OnInit {

  titleHomePage: string;
  filterOffreForm: UntypedFormGroup;
  isLogin: boolean;
  tabHome: string;
  mainMenu: MainMenu[];
  innerWidth: number;
  openSearch: boolean;
  showTags: boolean;

  constructor(
    private dataService: DataService,
    private formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    public router: Router,
    private route: ActivatedRoute,
    private menuService: MenuService,
    private dialog: MatDialog,
    private faIconService: FaiconService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.initComponent();
    this.initSub();
    this.initForm();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }


  getRouteNavigate(url: string) {
    switch (url) {
      case '/home':
        const urlInSessionStorage = sessionStorage.getItem('route');
        sessionStorage.getItem('route') ?
          this.router.navigateByUrl(urlInSessionStorage) :
          this.router.navigate([url]);
        break;

      default:
        this.router.navigate([url]);
        break;
    }

  }

  ifRouteActive(url: string): boolean {
    let urlActive = false;
    const { structure, universe } = this.route.snapshot.queryParams;

    if (url === this.router.url) {
      urlActive = true;
    } else if (url === '/home' && (structure || universe)) {
      urlActive = true;
    } else {
      urlActive = false;
    }
    return urlActive;
  }

  openSearchDiv(): void {
    this.dialog.open(OpenDialogSearchMobileComponent, {
      width: '100%',
      height: '85%'
    });
  }

  private initComponent(): void {
    this.mainMenu = this.menuService.mainMenu;
    this.innerWidth = window.innerWidth;
  }

  private initForm(): void {
    this.filterOffreForm = this.formBuilder.group({
      city: [''],
      start_date: [''],
      end_date: ['']
    });
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.titleHomePage.asObservable().subscribe({
          next: (titleHomePage) => { this.titleHomePage = titleHomePage; this.cdr.detectChanges(); }
        })
      )
      .add(
        this.dataService.openSearchOffer$.subscribe({
          next: openSearch => {
            this.openSearch = openSearch;
            this.cdr.detectChanges();
          }
        })
      )
      .add(
        this.dataService.showTagSearch$.subscribe({
          next: showTags => {
            this.showTags = showTags;
            this.cdr.detectChanges();
          }
        })
      );

  }

}
